import { PARCEIROS_ACCENT, fieldClass, labelClass } from './parceirosBrand'
import { useParceirosLeadForm } from './useParceirosLeadForm'

type Props = {
  onCreated: () => Promise<void> | void
}

export function ParceirosLeadForm({ onCreated }: Props) {
  const form = useParceirosLeadForm(onCreated)

  return (
    <form
      onSubmit={form.submit}
      className='grid gap-4 rounded-3xl border border-white/10 bg-white/[0.04] p-6 backdrop-blur-xl'
    >
      <div>
        <h2 className='text-lg font-black'>Cadastrar lead</h2>
        <p className='mt-1 text-sm text-white/60'>Envie os dados do cliente indicado. Sem copiar lista interna.</p>
      </div>

      <div className='grid gap-4 md:grid-cols-2'>
        <label className='grid gap-1.5'>
          <span className={labelClass}>Nome do contato</span>
          <input
            className={fieldClass}
            value={form.values.nome}
            onChange={(e) => form.patch('nome', e.target.value)}
            required
            minLength={2}
            maxLength={255}
          />
        </label>
        <label className='grid gap-1.5'>
          <span className={labelClass}>Empresa</span>
          <input
            className={fieldClass}
            value={form.values.empresa}
            onChange={(e) => form.patch('empresa', e.target.value)}
            required
            minLength={2}
            maxLength={255}
          />
        </label>
        <label className='grid gap-1.5'>
          <span className={labelClass}>Telefone</span>
          <input
            className={fieldClass}
            value={form.values.telefone}
            onChange={(e) => form.patch('telefone', e.target.value)}
            required
            minLength={8}
            maxLength={20}
            inputMode='tel'
            autoComplete='tel'
          />
        </label>
        <label className='grid gap-1.5'>
          <span className={labelClass}>E-mail</span>
          <input
            className={fieldClass}
            type='email'
            value={form.values.email}
            onChange={(e) => form.patch('email', e.target.value)}
            maxLength={255}
            autoComplete='email'
          />
        </label>
        <label className='grid gap-1.5 md:col-span-2'>
          <span className={labelClass}>Site</span>
          <input
            className={fieldClass}
            value={form.values.site}
            onChange={(e) => form.patch('site', e.target.value)}
            maxLength={500}
            placeholder='https://loja.com.br'
            inputMode='url'
          />
        </label>
        <label className='grid gap-1.5 md:col-span-2'>
          <span className={labelClass}>Observação</span>
          <textarea
            className={`${fieldClass} min-h-24 resize-y`}
            value={form.values.observacao}
            onChange={(e) => form.patch('observacao', e.target.value)}
            maxLength={500}
          />
        </label>
      </div>

      {form.error && <p className='text-sm text-red-300'>{form.error}</p>}
      {form.ok && <p className='text-sm text-emerald-300'>{form.ok}</p>}

      <button
        type='submit'
        disabled={form.submitting}
        className='rounded-full px-5 py-3 text-sm font-medium text-white active:scale-95 disabled:opacity-50'
        style={{ background: PARCEIROS_ACCENT }}
      >
        {form.submitting ? 'Enviando…' : 'Cadastrar lead'}
      </button>
    </form>
  )
}
